// istanbul ignore file
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { App, basename } from './app';

const routes = [
  {
    path: '*',
    element: <App />,
  },
];

const root = createRoot(document.getElementById('root') as HTMLDivElement);
const router = createBrowserRouter(routes, { basename });

root.render(<RouterProvider router={router} />);

window.addEventListener('popstate', () => {
  const isOutside = !window.location.pathname.startsWith(basename);
  if (isOutside) {
    window.location.reload();
  }
});
